import { useNavigate } from 'react-router-dom'

type ResourceType = 'clinic' | 'ad_supplier' | 'clinic_group' | 'ad_supplier_group'

const pathPrefix: Record<ResourceType, string> = {
  clinic: '/clinic',
  ad_supplier: '/ad-supplier',
  clinic_group: '/clinic-group',
  ad_supplier_group: '/ad-supplier-group',
}

const label: Record<ResourceType, string> = {
  clinic: '診所',
  ad_supplier: '廣告商',
  clinic_group: '診所集團',
  ad_supplier_group: '廣告商集團',
}

interface Props {
  type: ResourceType
  ids: number[]
}

export function ResourceChooser({ type, ids }: Props) {
  const navigate = useNavigate()

  return (
    <div className="p-8 max-w-2xl mx-auto">
      <h1 className="text-2xl font-semibold mb-4">選擇要進入的{label[type]}</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {ids.map((id) => (
          <button
            key={id}
            type="button"
            onClick={() => navigate(`${pathPrefix[type]}/${id}`)}
            className="p-4 border rounded hover:bg-gray-50 text-left"
          >
            <div className="text-sm text-gray-500">ID</div>
            <div className="text-lg font-medium">{id}</div>
          </button>
        ))}
      </div>
    </div>
  )
}
